import { siteConfig } from '../config/seo';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    adsbygoogle: any[];
  }
}

export const initializeAnalytics = (measurementId: string) => {
  if (!measurementId) return;
  
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() { window.dataLayer.push(arguments); }
  window.gtag('js', new Date());
  window.gtag('config', measurementId);
};

export const initializeAds = (adClientId: string) => {
  if (!adClientId) return;
  
  window.adsbygoogle = window.adsbygoogle || [];
};

export const trackPageView = (path: string, title: string) => {
  if (window.gtag) {
    window.gtag('event', 'page_view', {
      page_title: title,
      page_path: path,
      page_location: window.location.href
    });
  }
};